import React from 'react'

import Col from 'react-bootstrap/Col'

import Accordion from '../../accordion'

const TeacherContentTeacherAccordion = (props) => {
  return (
    <Col xs={12}>
      <Accordion
        title={props.title}
        open={props.open}
        children={props.children}
      />
    </Col>
  )
}

export default TeacherContentTeacherAccordion